// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"224":"e724750d","671":"400dee85","816":"424afc87"}[chunkId] + ".css";
};